import { render, staticRenderFns } from "./RejectOrderModal.vue?vue&type=template&id=002395dc&scoped=true&"
import script from "./RejectOrderModal.vue?vue&type=script&lang=js&"
export * from "./RejectOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./RejectOrderModal.vue?vue&type=style&index=0&id=002395dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002395dc",
  null
  
)

export default component.exports